import React from "react";
import styled from "styled-components";
import Icon, { IconName } from "./Icon";

const DOODLES: {
  icon: IconName;
  top: string;
  left: string;
  size: number;
  color: string;
  tilt: number;
  duration: number;
}[] = [
  { icon: "spade", top: "8%", left: "6%", size: 44, color: "var(--night)", tilt: -12, duration: 16 },
  { icon: "suitHeart", top: "18%", left: "84%", size: 38, color: "var(--cherry)", tilt: 10, duration: 14 },
  { icon: "suitDiamond", top: "62%", left: "8%", size: 34, color: "var(--teal)", tilt: 8, duration: 18 },
  { icon: "suitClub", top: "74%", left: "80%", size: 42, color: "var(--night)", tilt: -8, duration: 15 },
  { icon: "you", top: "40%", left: "92%", size: 26, color: "var(--gold)", tilt: 14, duration: 12 },
  { icon: "sparkles", top: "86%", left: "40%", size: 28, color: "var(--cherry)", tilt: -6, duration: 20 },
  { icon: "you", top: "34%", left: "3%", size: 22, color: "var(--teal)", tilt: -14, duration: 13 },
];

const Layer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
`;

const Doodle = styled.span<{ $duration: number; $tilt: number }>`
  position: absolute;
  opacity: 0.35;
  --tilt: ${({ $tilt }) => $tilt}deg;
  transform: rotate(var(--tilt));
  animation: float ${({ $duration }) => $duration}s ease-in-out infinite;
`;

/** Faint floating card suits behind every screen. Decorative only. */
const DoodleBackground: React.FC = () => (
  <Layer aria-hidden>
    {DOODLES.map(({ icon, top, left, size, color, tilt, duration }, i) => (
      <Doodle
        key={i}
        style={{ top, left, color }}
        $duration={duration}
        $tilt={tilt}
      >
        <Icon name={icon} size={size} strokeWidth={2.25} />
      </Doodle>
    ))}
  </Layer>
);

export default DoodleBackground;
